import React from 'react';
import PropTypes from 'prop-types';
import styles from './styles/StaticGauge.module.scss';

type StaticGaugeType = {
  radius?: number;
  stroke?: number;
  progress: number;
  color?: 'yellow' | 'green' | 'red';
};

const colors = {
  yellow: '#F9A31D',
  green: '#52B36B',
  red: '#ED5050',
};

export default function StaticGauge({
  progress,
  radius = 39,
  stroke = 6,
  color = 'green',
}: StaticGaugeType) {
  const normalizedRadius = radius - stroke * 2;
  const circumference = normalizedRadius * 2 * Math.PI;
  const strokeDashoffset = circumference - (progress / 100) * circumference;

  return (
    <div className={`${styles.progress}`}>
      <svg
        className={`${styles.progress__circle}`}
        height={radius * 2}
        width={radius * 2}
      >
        <>
          <circle
            className={`${styles.progress__circle__back}`}
            r={normalizedRadius}
            cx={radius}
            strokeWidth={stroke}
            cy={radius}
          />
          <circle
            className={`${styles.progress__circle__prog}`}
            stroke={colors[color]}
            fill="transparent"
            strokeWidth={stroke}
            strokeDasharray={`${circumference} ${circumference}`}
            style={{ strokeDashoffset }}
            r={normalizedRadius}
            cx={radius}
            cy={radius}
          />
          <text
            x={radius}
            y={`-${radius - 4}`}
            textAnchor="middle"
            style={{
              fill: colors[color],
            }}
            className={`${styles.progress__text}`}
          >
            {progress.toFixed(2)}%
          </text>
        </>
      </svg>
    </div>
  );
}

StaticGauge.propTypes = {
  radius: PropTypes.number,
  stroke: PropTypes.number,
  color: PropTypes.oneOf(['yellow', 'green', 'red']),
  progress: PropTypes.number.isRequired,
};

StaticGauge.defaultProps = {
  radius: 40.5,
  stroke: 6,
  color: 'green',
};
